<app-range-field [config]="config"></app-range-field>